__turbopack_context__.v({
  "actions": "NtmBaa_actions",
  "avatar": "NtmBaa_avatar",
  "badge": "NtmBaa_badge",
  "notificationBtn": "NtmBaa_notificationBtn",
});
